import { STTextAlignType } from '@tencent/slide-sdk-model';
import { IParagraphTextAlign } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';

// 段落对齐方式 - sdk对上层类型映射
export const TEXT_ALIGN_TYPE_MAP = new Map([
    [STTextAlignType?.dist, IParagraphTextAlign.DISTRIBUTE],
    [STTextAlignType?.ctr, IParagraphTextAlign.CENTER],
    [STTextAlignType?.l, IParagraphTextAlign.LEFT],
    [STTextAlignType?.r, IParagraphTextAlign.RIGHT],
    [STTextAlignType?.just, IParagraphTextAlign.JUSTIFY],
    [STTextAlignType?.justLow, IParagraphTextAlign.JUSTIFY], // 托底
    [STTextAlignType?.thaiDist, IParagraphTextAlign.LEFT], // 托底
]);
